import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
Backstage lists the software in the \`teamjourney\` GitHub organisation: who owns it,
what it depends on, what depends on it, and its docs and APIs.

### Add your repository

1. Add a \`catalog-info.yaml\` file to the root of the repository.
2. Set \`spec.owner\` to your team, for example \`group:default/ecommerce\`.
3. Use \`dependsOn\` and \`consumesApis\` to name the services and APIs that you use.
4. Merge to the default branch. Backstage finds the file within 30 minutes.

The [README](https://github.com/teamjourney/backstage#add-your-repository) explains
each field and lists the teams.

### Copy an example

| Repository | Shows |
| --- | --- |
| [good-spa-guide](https://github.com/teamjourney/good-spa-guide/blob/main/catalog-info.yaml) | A system with a website, a service and a database |
| [onejourney-api](https://github.com/teamjourney/onejourney-api/blob/release/catalog-info.yaml) | A service that provides OpenAPI definitions |
| [onejourney-ui](https://github.com/teamjourney/onejourney-ui/blob/release/catalog-info.yaml) | Websites and libraries from one monorepo |
| [providers-service](https://github.com/teamjourney/providers-service/blob/main/catalog-info.yaml) | A service with an API, a database and a cache |

### Find your way around

- [Catalogue](/): every system and component.
- [APIs](/api-docs): every API and its definition.
- Open an entity to see its dependencies and docs.

### Use Backstage from Claude

Backstage is an MCP server. Ask Claude questions such as "What depends on onejourney-api?".

- Claude Code: run \`claude mcp add --transport http backstage https://backstage.journey.travel/api/mcp-actions/v1\`, then run \`/mcp\` and select **Authenticate**.
- claude.ai, Claude Desktop or Cowork: add a custom connector with the URL \`https://backstage.journey.travel/api/mcp-actions/v1\`, then sign in with Google.

The [README](https://github.com/teamjourney/backstage#use-backstage-from-an-ai-assistant-mcp) has the full steps.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'Getting Started',
    description: 'How to add a repository to Backstage',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
